import { navLink, navSection } from "@lib/types"

// Array of Navbar main menu links
export const NAVLINKS: navLink[] = [
    {
        title: "ACCOMMODATION",
        path: "/accommodation"
    },
    {
        title: "DINING",
        path: "/dining"
    },
    {
        title: "EVENTS",
        path: "/events"
    },
    {
        title: "EXPERIENCES",
        path: "/experiences"
    },
    {
        title: "ABOUT",
        path: "/about"
    },
];

// Array of Navigation Sidebar Sections
export const NAVSECTIONS: navSection[] = [
    {
        title: "Accommodation",
        path: "/accommodation",
        navLinks: [
            {
                title: "Cabins",
                path: "/accommodation#cabins"
            },
            {
                title: "Facilities and Services",
                path: "/accommodation#facilities"
            },
            {
                title: "Exclusive Packages",
                path: "/packages"
            },
            {
                title: "Accessibility",
                path: "/about/accessibility"
            },
        ]
    },
    {
        title: "Dining",
        path: "/dining",
        navLinks: [
            {
                title: "Warrior Restaurant and Bar",
                path: "/dining#warrior"
            },
            {
                title: "Menus",
                path: "/menu"
            },
            {
                title: "Reservations",
                path: "/dining#reservation"
            },
            {
                title: "Gift Cards",
                path: "https://giftcards.thecrocodilehunterlodge.com.au/"
            }
        ]
    },
    {
        title: "Events",
        path: "/events",
        navLinks: [
            {
                title: "Events at Warrior",
                path: "/events/warrior"
            },            {
                title: "Weddings",
                path: "/weddings"
            },            {
                title: "Private Functions",
                path: "/functions"
            }
        ]
    },
    {
        title: "Experiences",
        path: "/experiences",
        navLinks: [
            {
                title: "Australia Zoo",
                path: "/experiences#australiazoo"
            },
            {
                title: "Australia Zoo Wildlife Hospital",
                path: "/experiences#hospital"
            },
            {
                title: "Sunshine Coast",
                path: "/experiences/sunshinecoast"
            }
        ]
    },
    {
        title: "About",
        path: "/about",
        navLinks: [
            {
                title: "Our Story",
                path: "/about/story"
            },
            {
                title: "Contact Us",
                path: "/about#contact"
            },
            {
                title: "Map and Directions",
                path: "/about/directions"
            },
            {
                title: "Gallery",
                path: "/about/gallery"
            },
            {
                title: "Awards",
                path: "/about/awards"
            },
            {
                title: "FAQ",
                path: "/about/faq"
            }
        ]
    }
];